class Navigation {
  constructor() {
    this.menuItems = document.querySelectorAll('.wp-subnav .wp-menu-a__item--has-children > .wp-menu-a__link--level-0');
    this.menuFirstItems = document.querySelectorAll('.wp-subnav .wp-menu-a__item--has-children > .wp-menu-a__link--level-1');
    this.menuSecondItems = document.querySelectorAll('.wp-subnav .wp-menu-a__item--has-children > .wp-menu-a__link--level-2');
    this.menuOffsettingItems = document.querySelectorAll('.wp-menu-a__wrap--level-1');

    this.menuSubnav = document.querySelector('.wp-subnav');
    this.menuBackground = document.querySelector('.wp-menu__background');
    this.menuBackdrop = document.querySelector('.wp-menu__backdrop');

    this.menuBackgroundHeight = 0;

    if(this.menuOffsettingItems){
      this.bindMenuOffsetting();
    }

    if(this.menuItems){
      this.bindMenu();
    }

    if(this.menuFirstItems){
      this.bindMenuLevels(this.menuFirstItems, 1);
    }

    if(this.menuSecondItems){
      this.bindMenuLevels(this.menuSecondItems, 2);
    }

    if(this.menuBackdrop){
      this.bindBackdrop();
    }

    window.addEventListener('resize', () => {
			this.bindMenuOffsetting();
		});
  }

  bindMenuOffsetting(){
    this.menuOffsettingItems.forEach(item => {
      let menuOffset = document.querySelector('.wp-subnav > ul').offsetLeft;
      item.style.paddingLeft = menuOffset + 24 + "px";
    })
  }

  bindMenu(){
    this.menuItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        let openNav = document.querySelector('.wp-menu--active-0');
        let newHeight = false;

        if(openNav){
          openNav.classList.toggle('wp-menu--active');
          openNav.classList.toggle('wp-menu--active-0');
          newHeight = true;
          this.removeActive();
          this.removeActive('wp-menu--active-1');
          this.removeActive('wp-menu--active-2');
          this.removeOpacity();
        }

        item.closest('.wp-menu-a__item--level-0').classList.toggle('wp-menu--active');
        item.closest('.wp-menu-a__item--level-0').classList.toggle('wp-menu--active-0');

        this.bindOpacity(item);

        let height = item.nextElementSibling.querySelector('.wp-menu-a--level-1').offsetHeight;

        this.bindBackground(height + 64, newHeight);
        this.menuBackdrop.style.display = 'block';

        this.menuSubnav.classList.add('wp-subnav--active');
      });
    });
  }

  bindMenuLevels(menuItems, num){
    menuItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        let openNav = document.querySelector('.wp-menu--active-' + num);
        let newHeight = false;

        if(openNav){
          openNav.classList.toggle('wp-menu--active');
          openNav.classList.toggle('wp-menu--active-' + num);
          this.removeActive('wp-menu--active-' + (num + 1));
          this.removeOpacity('.wp-menu-a__wrap--level-' + (num + 1));
          this.removeOpacity('.wp-menu-a__wrap--level-' + (num + 2));

          let heights = document.querySelectorAll('.wp-menu--active > div > ul');
          heights.forEach(item => {
            if(item.offsetHeight > newHeight){
              newHeight = item.offsetHeight;
            }
          });

        }

        let link = item.closest('.wp-menu-a__item--level-' + num);
        let height = link.closest('.wp-menu-a--level-' + num).offsetHeight;
        link.classList.toggle('wp-menu--active');
        link.classList.toggle('wp-menu--active-' + num);
        let offset = item.closest('.wp-menu-a--level-' + num).offsetWidth;
        let menu = item.nextElementSibling;

        this.bindOpacity(item);

        let menuHeight = menu.offsetHeight;
        item.closest('.wp-menu-a__wrap--level-1').style.minHeight = menuHeight + "px";
        menu.style.minHeight = height + "px";
        menu.style.left = offset + (28 * num) + "px";

        if(newHeight && newHeight >= menuHeight){
          this.bindBackground(newHeight + 64, true);
        } else {
          this.bindBackground(menuHeight + 64);
        }
      });
    });
  }


  bindBackground(height, close = false){
    if(height > this.menuBackgroundHeight || close){
      this.menuBackground.style.height = height + 'px';
      this.menuBackgroundHeight = height;
    }
  }

  bindBackdrop(){
    this.menuBackdrop.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeMenu();
    });
  }

  bindOpacity(item){
    item.nextElementSibling.classList.add('wp-menu__opacity--start');
    setTimeout(() => {
      item.nextElementSibling.classList.add('wp-menu__opacity--end');
    },100);
  }

  removeActive(removeClass = 'wp-menu--active'){
    this.menuActive = document.querySelectorAll('.' + removeClass);
    this.menuActive.forEach(item => {
      item.classList.remove('wp-menu--active');
      item.classList.remove(removeClass);
    });
  }

  removeOpacity(removeClass = '.wp-menu__opacity--end'){
    this.menuOpacityActive = document.querySelectorAll(removeClass);
    this.menuOpacityActive.forEach(item => {
      item.classList.remove('wp-menu__opacity--end');
    });
  }

  closeMenu(){
    this.removeActive();
    this.removeOpacity();
    this.bindBackground(0,true);
    this.menuBackdrop.style.display = 'none';
    this.menuSubnav.classList.remove('wp-subnav--active');
  }
}

export default Navigation;
